import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { ThemeProvider, css } from "styled-components";
import DatePicker from "react-datepicker";
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'


const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;


var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;



const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xls';

const exportToCSV = (csvData,fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  const Heading = [['Warehouse',	'Brand', 'STO ID',	'STO Created'	,'ERP STO Update',	'STI ID','ERP STI Update',	'Packslip ID',	'STN ID',	'Created in CD',	'Receiving Confirmed by User',	'ERP GR Update',	'Bill Count',
]];
  const ws = XLSX.utils.json_to_sheet(csvData,{ origin: 'A2', skipHeader: true });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xls', type: 'array' });
  const data = new Blob([excelBuffer], {type: fileType});
  FileSaver.saveAs(data, fileName + fileExtension);
}


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchCycleCountData = this.fetchCycleCountData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,
      invoice_no : "",
      trip_id : "",
      isLoading: true,
      showFetchBinData: false,
      show_process_data: true,
      from_date: "",
      to_date: "",
      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData : [],
      sto_no : "",
      

    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      showFromErr: false

    })
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({
        fromdate: ""
      })
      From_Date_val = ""
    }


  }

  ToDateChange = date => {

    this.setState({
      to_date: date,
      showToErr: false
    })
    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({
        to_date: "",

      })
      to_Date_val = ""
    }

  }
  
  onStoChange = (evt)=>{
    this.setState({
      sto_no : evt.target.value,
    })
  }

  fetchCycleCountData() {

    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

    const payload = {
      fromdate: From_Date_val,
      todate: to_Date_val,
      sto_no : this.state.sto_no,
    };
    API.post('/reports/sto_report', { param: payload })
      .then(response => response.data)

      .then(data => {

        console.log(data);

        this.setState({ tableRows: this.assemblePosts(data.data)})

      })

      .then(async () => {

        this.setState({  isLoading: false ,loading_overlay: false})

       

      });
  }

  filterData = (evt) => {
    var arr = []
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );

        for(var i = 0; i< value.length; i++){
          var obj = {};

          obj['warehouse'] = value[i].warehouse;
          obj['brand'] = value[i].brand;
          obj['sto_no'] = value[i].sto_no;
          obj['sto_date'] = value[i].sto_date;
          obj['sto_erp_log'] = value[i].sto_erp_log;
          obj['sti_no'] = value[i].sto_packslip_no;
          obj['sto_erp_log'] = value[i].sto_erp_log;
          obj['sto_packslip_no'] = value[i].sti_no;
          obj['stn_id'] = value[i].stn_id;
          obj['confirm_time'] = value[i].confirm_time;
          obj['confirm_time'] = value[i].confirm_time;
          obj['gr_push_date'] = value[i].gr_push_date;
          obj['bill_count'] = value[i].bill_count;


          arr.push(obj);

        }
      
        this.setState({
          filtered_orderData: arr,
        });
      }
    };

  assemblePosts = (data) => {

    let posts = data.map((post) => {
      return (
       
        {
          warehouse: post.warehouse,
          brand : post.brand,
          sto_no : post.sto_no,
          sto_created : post.sto_date,
          erp_sto_update : post.sto_erp_log,
          sti_id : post.sto_packslip_no,
          erp_sti_update : post.sto_erp_log,
          packslip_id : post.sti_no,
          stn_id : post.stn_id,
          received_in_cd : post.confirm_time,
          received_confirm : post.confirm_time,
          erp_gr_update : post.gr_push_date,
          bill_count : post.bill_count,
        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      orderData : posts,
      filtered_orderData : posts
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  render() {

    const data = {

      columns: [
        {
          label: ' Warehouse',
          field: 'warehouse',
          sort: 'asc',
          width: 140,

        },
        {
          label: 'Brand',
          field: 'brand',
          sort: 'asc',
          width: 100,

        },
        {
          label: 'STO	ID',
          field: 'sto_no',
          sort: 'asc',
          width: 130,

        },
        {
          label: 'STO	Created',
          field: 'sto_created',
          sort: 'asc',
          width: 150,

        },
        {

          label: 'ERP STO Update',
          field: 'erp_sto_update',
          width: 150,
          sort: 'asc',

        }, 
        {
          label: 'STI ID',
          field: 'sti_id',
          sort: 'asc',
          width: 150,

        },
        {
          label: 'ERP STI Update',
          field: 'erp_sti_update',
          width: 150,
          sort: 'asc',

        },
        {

          label: 'Packslip ID',
          field: 'packslip_id',
          width: 150,
          sort: 'asc',

        },
        {
          label: 'STN	ID',
          field: 'stn_id',
          width: 150,
          sort: 'asc',

        },
        {
          label : 'Created in CD',
          field : 'received_in_cd',
          width :  120,
          sort  : 'asc'

        },
        {
          label : 'Receiving Confirmed by User',
          field : 'received_confirm',
          width :  150,
          sort  : 'asc'

        },

        {

          label: 'ERP GR Update',
          field: 'erp_gr_update',
          width: 150,
          sort: 'asc',
        },
        {

          label: 'Bill Count',
          field: 'bill_count',
          width: 110,
          sort: 'asc',

        },
       


      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
        <Overlay>
          <form className="form">
            <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
              <span className="filter_title">Filters</span>
            </div>

            <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
              <span className="date_title">From Date</span>
              <div style={{ position: 'relative' }}>

                <DatePicker
                  selected={this.state.from_date}
                  onChange={this.FromDateChange}
                  className="ledger_fromdate"
                  placeholderText="From Date"
                  format='yyyy-MM-dd'

                />

                {this.state.showFromErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                }
              </div>
            </div>

            <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
              <span className="date_title">To Date</span>
              <div style={{ position: 'relative' }}>

                <DatePicker
                  selected={this.state.to_date}
                  onChange={this.ToDateChange}
                  className="ledger_todate"
                  placeholderText="To Date"
                />
                {this.state.showToErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                }
              </div>
            </div>
            <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
              <span className="date_title">STO Number</span>
              <div style={{ position: 'relative' }}>

                  <input type = "text" style={{height: 38}} className="form-control" placeholder= "STO Number" onChange={this.onStoChange}/>
              </div>
            </div>

            <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
              <ButtonToolbar className="form__button-toolbar">
                <Button
                  className="btn-sm button_enable1 "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                  }}
                  id="button_view"
                  onClick={() => this.fetchCycleCountData()}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  View
                </Button>
                <Button
                  type="button"
                  className="btn btn-primary-outline"
                  style={{
                      cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                      backgroundColor: '#FFFFFF',
                      color: '#333333', // Set text color
                      display: 'flex',   // Use flexbox to align image and text
                      alignItems: 'center' // Center items vertically
                  }}
                  id="button_download"
                  onClick={(e) => exportToCSV(this.state.filtered_orderData, "Sto Report")}>
                  <img
                      src={DownloadIcon}
                      alt="Download"
                      style={{ width: '22px' }} // Adjust size as needed
                  />
                  Download
                </Button>
              </ButtonToolbar>
            </div>
          </form>
        </Overlay>

        {!this.state.showFetchBinData && (
          <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
             <img style={{width: '10%'}} src={EmptyDataIcon} />
              <p className="noDataTextStyle">
              Choose your filters from the available options. The data will display
            </p>
            <p className="noDataTextStyle2">
               here once the filters have been applied.
            </p>
          </div>
        )}
        
        {this.state.showFetchBinData && (

          <div>
            <div>

              {From_Date_val &&
                <div className="date-container">
                 {From_Date_val}
                </div>
              }

              {to_Date_val &&
                <div className="date-container">
                 {to_Date_val}
                </div>
              }
              {this.state.sto_no &&
                <div className="date-container">
                 {this.state.sto_no}
                </div>
              }

            </div>
            <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
            {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
            
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
             
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  hover
                  onSearch={this.filterData}
                  data={data}
                  // style={{ textAlign: "center" }}
                />
              </div>
            </div>
             
          </div>
        )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));